import { render, staticRenderFns } from "./Myprojects.vue?vue&type=template&id=616e132c&"
import script from "./Myprojects.vue?vue&type=script&lang=js&"
export * from "./Myprojects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports